import { useState, useEffect, useRef } from "react";
import styles from "../../../layout/admin/Main.module.scss";
import { Link } from "react-router-dom";
//共通コンポーネント
import DataTable from "../../../features/DataTable";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
//専用コンポーネント
import CourseModalSearchFrom from "./CourseModalSearchFrom";
//API
import { getCourseList } from "../../../../services/apiNotification";
//定数
import { OLD_SITE_ID, SITE_ID } from "../../../../utils/config";
import modalStyles from "../../../layout/admin/Modal.module.scss";

//テーブル情報
const tableMeata = [
  { key: "id", label: "講座ID" },
  { key: "course_name", label: "講座名" },
  { key: "period", label: "講座開催日・講座時間" },
  { key: "organ", label: "実施機関" },
  { key: "univ_id", label: "大学ID" },
];
//検索条件・公開ステータス_公開
//FORMを挟むと文字列になるので文字列型で宣言
const controled = "1";
const disControld = "0";

const CourseModal = (props) => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 一覧データ
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const tableResetRef = useRef();
  // ローディング表示
  const [loading, setLoading] = useState(false);

  // 検索実行
  useEffect(() => {
    if (!props.showFlag) return;
    //
    const returnCourseNameLink = (id, name) => {
      return (
        <a href="javascript:void(0);" onClick={() => closeModal(id, name)}>
          {name}
        </a>
      );
    };
    const mapTableFunc = (d) => {
      return {
        key: d.id,
        id: d.id,
        course_name: returnCourseNameLink(d.id, d.course_name),
        period: d.period,
        organ: d.organ,
        univ_id: d.univ_id,
      };
    };
    const mapTableSortFunc = (d) => {
      return {
        key: d.id,
        id: d.id,
        course_name: d.course_name,
        period: d.period,
        organ: d.organ,
        univ_id: d.univ_id,
      };
    };
    setTableData([]);
    setTableSortData([]);
    //非同期でテーブルデータを取得
    (async function () {
      setLoading(true);
      if (searchCondition.control === controled) {
        //公開
        const data = await getCourseList(searchCondition);
        if (data == null) {
          return;
        }
        //テーブルデータに追加
        setTableData(data.data_list.map(mapTableFunc));
        setTableSortData(data.data_list.map(mapTableSortFunc));
        //ページネーション・ソートをリセット
        tableResetRef.current?.click();
      } else if (searchCondition.control === disControld) {
        //非公開
        let newTableData = [];
        let newSortData = [];
        let siteIds = [OLD_SITE_ID, SITE_ID];
        for (let index = 0; index < siteIds.length; index++) {
          for (let i = 0; i < 1000; i++) {
            const data = await getCourseList(
              searchCondition,
              i,
              siteIds[index]
            );
            if (data.is_end || !data.data_list) {
              // 検索条件に関わらず1件もAPIからデータが取得できなくなった場合
              break;
            }
            //テーブルデータに追加
            newTableData = [
              ...newTableData,
              ...data.data_list.map(mapTableFunc),
            ];
            newSortData = [
              ...newSortData,
              ...data.data_list.map(mapTableSortFunc),
            ];
          }
        }
        setTableData(newTableData);
        setTableSortData(newSortData);
        //ページネーション・ソートをリセット
        tableResetRef.current?.click();
      }
      setLoading(false);
    })();
  }, [searchCondition]); //検索実行;

  const closeModal = (id, name) => {
    // モーダル閉じる
    props.setShowModal(false);
    // 学生情報セット
    props.setCourseInfo({ course_id: id, name: name });
  };

  const closeModalNoSet = () => {
    // なにもせずにモーダル閉じる
    props.setShowModal(false);
  };

  return (
    <>
      {props.showFlag ? (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.modalContent}>
            <div className={modalStyles.modalButtonWrap}>
              <button
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModalNoSet()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <div className="sk-main">
              <SubScreenTitle>講座検索</SubScreenTitle>
              <CourseModalSearchFrom setSearchCondition={setSearchCondition} />
              <DataTable
                tableData={tableData}
                tableMeata={tableMeata}
                tableSortData={tableSortData}
                tableResetRef={tableResetRef}
              />
              <div className={styles.buttonbox}>
                <a onClick={() => closeModalNoSet()}>
                  <span className={styles.decoration}>閉じる</span>
                </a>
              </div>
              {loading ? <Loading /> : <></>}
              {loading ? <Progress /> : <></>}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CourseModal;
